import { ReactNode, useMemo } from 'react';
import { App } from 'antd';

import { NoticeOptions } from './types';
import { useAntdNotificationsContext } from './useAntdNotificationsContext';

export const useNotices = () => {
  const antdNotifications = useAntdNotificationsContext();
  const antApp = App.useApp();

  return useMemo(() => {
    return {
      success: (content: ReactNode, options?: NoticeOptions) => {
        antApp.message.success({ content, key: options?.key }, options?.delay);
      },
      error: (content: ReactNode, options?: NoticeOptions) => {
        antApp.message.error({ content, key: options?.key }, options?.delay);
      },
      antd: antdNotifications,
    };
  }, [antApp]);
};
